module.exports = __webpack_public_path__ + "img/rectangleUnload.e080a360.svg";